import { Dispatch, SetStateAction, useEffect } from 'react';
import { profileService } from '../services/profileService';
import { TUser } from '../context/UsersProvider';

export function useLanguage(
    setProfile: Dispatch<SetStateAction<TUser>>,
    setLoading: Dispatch<SetStateAction<boolean>>,
    getProfile: (setAlertMessages: (msgs: Partial<Record<string, string[]>>) => void) => Promise<TUser | undefined>
) {
    const changeLanguage = async (
        lang: string,
        setAlertMessages: (msgs: Partial<Record<string, string[]>>) => void
    ) => {
        try {
            const response = await profileService.changeLanguage(lang);
            setProfile(response.data);
            setLoading(false);
        } catch (error: any) {
            setAlertMessages(error.response.data);
        }
    };

    useEffect(() => {
        const storedLang = localStorage.getItem('language');
        if (storedLang) {
            changeLanguage(storedLang, () => {});
        } else {
            getProfile(() => {}).then((profile) => {
                if (profile?.language) {
                    changeLanguage(profile.language, () => {});
                    localStorage.setItem('language', profile.language);
                }
            });
        }
    }, []);

    return {
        changeLanguage,
    };
}
